import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            isLoading: false,
            subscribed: false,
        };
    },
    computed: {
        ...mapGetters(['user']),
    },
    methods: {
        dispatchNewsletterEvent(hasVehicle = false) {
            const event = 'lead_newsletter';
            const label = hasVehicle ? 'has vehicle' : null;
            const currentPage = this.$route.name || this.$route.path;
            const method = currentPage.includes('magazine') ? 'magazine' : 'platform';

            if (this.$gtm.enabled()) {
                window.dataLayer?.push({
                    event,
                    method,
                    label,
                });
            }
        },
        handleLoggedInSubscription() {
            this.isLoading = true;
            const shouldBeSubscribed = !this.user.subscriptions?.newsletter;

            this.$meService
                .updateSubscription('newsletter', shouldBeSubscribed)
                .then(() => {
                    this.subscribed = true;
                    this.dispatchNewsletterEvent();
                })
                .catch(err => {
                    this.$sentry.captureException(err);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        handleGuestSubscription(formData, source = 'newsletter') {
            this.isLoading = true;
            const { name, familyName, email, hasVehicle } = formData;
            const newLeadInfo = {
                email,
                source,
                firstName: name,
                preferredLocale: this.$i18n.localeProperties.iso,
            };

            if (familyName) {
                newLeadInfo.lastName = familyName;
            }

            this.$leadService
                .createLead(newLeadInfo)
                .then(() => {
                    this.subscribed = true;
                    this.dispatchNewsletterEvent(hasVehicle);
                })
                .catch(err => {
                    this.$sentry.captureException(err);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
